// @ts-check
import {
  LinearBBuddyIllustration,
  lightColorPalette
} from '@linearb/linui-common';
import styled from 'styled-components';

export const EducationalTabsWrapper = styled.div`
  position: relative;
  border-radius: 0.45rem;
  border: 1px solid ${lightColorPalette.lbGreyDisabled};
  background: ${lightColorPalette.lbBlue_5};
  width: 100%;

  .MuiTabs-root {
    padding: 2.2rem 9rem 0;
  }

  div[role='tabpanel'] {
    padding: 0 9rem;

    .MuiBox-root {
      padding: 1rem 2rem;
    }
  }
`;

export const Buddy = styled(LinearBBuddyIllustration)`
  position: absolute;
  top: 1.1rem;
  left: 1.1rem;
  height: 60px;
`;
